{
  "trailblazers.recommendation-jsw-jtbd.generic.description": [
    {
      "type": 0,
      "value": "Track work from start to finish"
    }
  ],
  "trailblazers.recommendation-jsw-jtbd.generic.jtbd": [
    {
      "type": 0,
      "value": "Project board"
    }
  ],
  "trailblazers.recommendation-jsw-jtbd.lozenge.try": [
    {
      "type": 0,
      "value": "Try"
    }
  ],
  "trailblazers.recommendation-jsw-jtbd.marketing.description": [
    {
      "type": 0,
      "value": "Easily plan and prioritize work"
    }
  ],
  "trailblazers.recommendation-jsw-jtbd.marketing.jtbd": [
    {
      "type": 0,
      "value": "Marketing project"
    }
  ],
  "trailblazers.recommendation-jsw-jtbd.operations.description": [
    {
      "type": 0,
      "value": "Visualize, plan, and finish work"
    }
  ],
  "trailblazers.recommendation-jsw-jtbd.operations.jtbd": [
    {
      "type": 0,
      "value": "Operations project"
    }
  ],
  "trailblazers.recommendation-jsw-jtbd.pm.description": [
    {
      "type": 0,
      "value": "See work in to-do, doing, done"
    }
  ],
  "trailblazers.recommendation-jsw-jtbd.pm.jtbd": [
    {
      "type": 0,
      "value": "Plan and track work"
    }
  ],
  "trailblazers.recommendation-jsw-jtbd.swe.description": [
    {
      "type": 0,
      "value": "Track work from start to finish"
    }
  ],
  "trailblazers.recommendation-jsw-jtbd.swe.jtbd": [
    {
      "type": 0,
      "value": "Project tracker"
    }
  ],
  "trailblazers.xflow-notification-end-user-added-jira.message-template.email.subject": [
    {
      "type": 0,
      "value": "🎉 "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": " has started using Jira"
    }
  ],
  "trailblazers.xflow-notification-end-user-added-jira.message.email.admin-url.no-translate": [
    {
      "type": 0,
      "value": "admin.atlassian.com"
    }
  ],
  "trailblazers.xflow-notification-end-user-added-jira.message.email.headline": [
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": " has started using Jira!"
    }
  ],
  "trailblazers.xflow-notification-end-user-added-jira.message.email.lead-paragraph": [
    {
      "type": 0,
      "value": "Jira has been added to "
    },
    {
      "type": 1,
      "value": "instanceUrl"
    },
    {
      "type": 0,
      "value": ". You don’t need to do anything. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Jira is free for up to 10 users."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " You can cancel any time at "
    }
  ],
  "trailblazers.xflow-notification-end-user-added-jira.message.email.sent-by-atlassian": [
    {
      "type": 0,
      "value": "This message has been sent to you by Atlassian Cloud"
    }
  ],
  "trailblazers.xflow-notification-end-user-added-jira.message.email.take-tour.button": [
    {
      "type": 0,
      "value": "Take a tour"
    }
  ],
  "trailblazers.xflow-notification-end-user-added-jira.message.email.value-prop.achievable-tasks": [
    {
      "type": 0,
      "value": "🚀 Jira is a tool designed to break down any idea into achievable tasks."
    }
  ],
  "trailblazers.xflow-notification-end-user-added-jira.message.email.value-prop.connect-realtime": [
    {
      "type": 0,
      "value": "↔️ Connect real-time data from Jira to any document in Confluence, no more copy paste."
    }
  ],
  "trailblazers.xflow-notification-end-user-added-jira.message.email.value-prop.visualise": [
    {
      "type": 0,
      "value": "👀 Visualize your projects in lists, boards, backlogs, and more."
    }
  ]
}